import React from 'react';
import Input from '../../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../../Core/Fields/Floating/SelectSearch';
import CheckboxNew from '../../../../../Core/Fields/Floating/CheckboxNew';

const SalesDetails = ({ formData, onFieldChange, extraData }) => {
  return (
    <div className="col-md-12">
      <div
        style={{
          backgroundColor: '#FDF8ED',
          height: '100%',
          borderRadius: '4px',
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          padding: '10px',
          border: '1px solid #ccc',
        }}
      >
        {/* Row 1 */}
        <div style={{ display: 'flex', gap: '15px', marginBottom: '15px' }}>
          <div style={{ flex: 1 }}>
            <SelectSearch
              label="Default Sales Unit of Measure"
              style={{ height: '30px' }}
              list={extraData.uoms}
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={formData.default_sales_unit_of_measure}
              onChange={(val) =>
                onFieldChange('default_sales_unit_of_measure', val)
              }
            />
          </div>

          <div style={{ flex: 1 }}>
            <Input
              label="Maximum Discount (%)"
              style={{ height: '30px' }}
              value={formData.max_Discount}
              onChange={(e) => onFieldChange('max_Discount', e.target.value)}
            />
          </div>
                    <div style={{ flex: 1, display: 'flex', alignItems: 'center',marginTop : '20px' }}>
            <CheckboxNew
              id="grant_commission"
              label="Grant Commission"
              labelPosition="right"
              checked={formData.grant_commission}
              onChange={(e) => onFieldChange('grant_commission', e.target.checked)}
            />
          </div>

          <div style={{ flex: 1, display: 'flex', alignItems: 'center',marginTop : '20px' }}>
            <CheckboxNew
              id="allow_sales"
              label="Allow Sales"
              labelPosition="right"
              checked={formData.allow_sales}
              onChange={(e) => onFieldChange('allow_sales', e.target.checked)}
            />
          </div>
        </div>

    
      </div>
    </div>
  );
};

export default SalesDetails;
